import { createContext, useContext, useEffect } from "react";

import { Modal, message as antdMessage } from "antd";

const ModalMessageContext = createContext({});

export const ModalMessageProvider = ({ children }) => {
  const [message, messageContextHolder] = antdMessage.useMessage();
  const [modal, modalContextHolder] = Modal.useModal();

  useEffect(() => {
    window.antdMessageApi = message;
    window.antdModalApi = modal;
  }, [message, modal]);

  const value = {
    message,
    modal,
  };

  return (
    <ModalMessageContext.Provider value={value}>
      {children}
      {messageContextHolder}
      {modalContextHolder}
    </ModalMessageContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalMessageContext);

  if (context === undefined) {
    throw new Error("useModal must be used within ModalMessageProvider");
  }

  return context.modal;
};

export const useMessage = () => {
  const context = useContext(ModalMessageContext);

  if (context === undefined) {
    throw new Error("useMessage must be used within ModalMessageProvider");
  }

  return context.message;
};
